import React, { lazy, Suspense } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

// react-perfect-scrollbar component
import PerfectScrollbar from "react-perfect-scrollbar";
// react-perfect-scrollbar styles
import "react-perfect-scrollbar/dist/css/styles.css";

import { QueryClient, QueryClientProvider } from "react-query";
import Loader from "./app/components/loader/Loader";
import './assets/css/global-style.scss';
import { SidebarContextProvider } from "./app/context/sidebarState";
import { Provider } from 'react-redux';
import { store } from "./redux/store";
import './index.css';

const App = lazy(() => import("./App"));

const container = document.getElementById("root");
const root = createRoot(container);

const queryClient = new QueryClient();

root.render(
  <Suspense fallback={
    <div className="whole-page-loader-container">
      <Loader dotsColor={'black'} />
    </div>
  }
  >
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter basename="/">
          <PerfectScrollbar>
            <SidebarContextProvider>
              <App />
            </SidebarContextProvider>
          </PerfectScrollbar>
        </BrowserRouter>
      </QueryClientProvider>
    </Provider>

  </Suspense>
);
